<div class="cbc-note-dialog">
  <div [innerHTML]="detailText | apiColourHtml"></div>
</div>
